import React, { useState } from 'react';
import { Application } from '../../../../../../../../entities/Application';
import {
  AlertObject,
  AlertType,
} from '../../../../../../../../components/Alert';
import { IconButton } from '../../../../../../../../components/IconButton';
import { AddTagModal } from '../../../../../../../CandidatePage/ProfileTab/TagsPanel/AddTagModal';

interface PropTypes {
  application: Application;
  setAlert: (alert: AlertObject) => void;
  onTagsAdded: () => void;
}

export function AddTag(props: PropTypes) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  if (!props.application.upsertTagsEnabled) return null;

  const setAlert = (alert: AlertObject) => {
    if (alert.type === AlertType.Success) {
      props.setAlert({
        type: AlertType.Success,
        message: 'The tag(s) was successfully added.',
      });
    } else {
      props.setAlert(alert);
    }
  };

  return (
    <>
      {isModalOpen && (
        <AddTagModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          applicationId={props.application.id}
          onTagsAdded={props.onTagsAdded}
          setAlert={setAlert}
        />
      )}
      <IconButton
        iconName='bi-tags'
        iconClass='text-info'
        buttonClass='me-2h'
        color='secondary'
        tooltipText='Add Tags'
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
